// extracted by mini-css-extract-plugin
export default {"content":"InfoCustomer_content__T8vVT","customer_order_details":"InfoCustomer_customer_order_details__bMIxx"};